import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/enterprise';

export const EnterpriseAPI = {
    ENTERPRISE_GET_SETUP: {
        url: `${BasePath}/get-setup`,
        type: API_TYPE.GET,
    },
};
